import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { UserConfig } from '@ils/config/db/user-config.js';
import { getUserConfigForKeyResolver } from '@ils/config/server/resolver.js';
import type { DataViewConfigKey } from '@ils/static/enums.js';

const getUserConfigForKeyOp = registerQuery({
  type: () => UserConfig,
  operationName: 'getUserconfigForKey',
  params: [
    { type: () => String, name: 'className' },
    { type: () => String, name: 'key' },
  ],
  resolve: getUserConfigForKeyResolver,
});

export const getUserConfigForKey = <T extends typeof UserConfig>(entity: T, key: DataViewConfigKey) =>
  getUserConfigForKeyOp<T['prototype']>(entity._class, key);
